import React from 'react'
import { Editor } from '@tinymce/tinymce-react'

const Tinymce = ({ init, initialValue, onChange }) => (
  <Editor
    apiKey="qbx6j81iipv1kdewcbxt696sp1rs4926441i505neddn6u5e"
    init={Object.assign({
      menubar: false,
      statusbar: false,
      language_url: 'https://olli-suutari.github.io/tinyMCE-4-translations/ja.js',
      language: 'ja',
      toolbar_items_size: 'small',
      default_link_target: '_blank'
    }, init)}
    initialValue={initialValue}
    onChange={onChange}
  />
)
export default Tinymce



// WEBPACK FOOTER //
// ./src/components/Tinymce.js